"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelPersonStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
const constants_1 = require("../../theme/constants");
exports.PanelPersonStyled = styled.div.attrs({ className: 'octo' }) `
&.octo {
  display: flex;
  flex-flow: column nowrap;
  gap: 1.5em;
  align-items: stretch;
  justify-content: flex-start;

  h2 {
    display: flex;
    flex-flow: row nowrap;
    gap: 1em;
    align-items: center;
    justify-content: space-between;
    margin: 1em 0 0;
    font-weight: 600;

    @media (min-width: ${constants_1.sizes.tablet}) {
      flex-flow: row nowrap;
    }

    @media (max-width: ${constants_1.sizes.tablet}) {
      flex-flow: column nowrap;
    }

    > span {
      font-size: 1.5em;
    }
  }

  >.header {
    display: flex;
    justify-content: stretch;

    @media (min-width: ${constants_1.sizes.tablet}) {
      flex-flow: row nowrap;
      gap: 2em;
      align-items: stretch;
    }

    @media (max-width: ${constants_1.sizes.tablet}) {
      flex-flow: column nowrap;
      gap: 1em;
      align-items: center;
    }

    >.bio {
      display: flex;
      flex: 1;
      flex-flow: column nowrap;
      gap: 1em;
      align-items: stretch;
      justify-content: stretch;
      width: 100%;
      padding-left: 2%;

      @media (min-width: ${constants_1.sizes.tablet}) {
        align-items: stretch;
      }

      @media (max-width: ${constants_1.sizes.tablet}) {
        align-items: center;
      }

      >.identity {
        display: flex;
        flex-direction: row;
        justify-content: start;
        width: 100%;

        @media (min-width: ${constants_1.sizes.tablet}) {
          flex-direction: row;
          align-items: stretch;
        }

        @media (max-width: ${constants_1.sizes.tablet}) {
          flex-direction: column;
          align-items: center;
        }

        > img {
          width: 10em;
          height: 10em;
          border-width: 0.125em;
          border-style: solid;
          border-color: ${design_system_1.theme.colors.marine[100]};
          border-radius: 5em;
        }

        >.identity-center {
          display: flex;
          flex-direction: column;
          gap: 0.8em;
          justify-content: center;
          width: 70%;
          margin-left: 10%;

          @media (min-width: ${constants_1.sizes.tablet}) {
            width: 70%;
            margin-left: 10%;
          }

          @media (max-width: ${constants_1.sizes.tablet}) {
            width: 100%;
            margin-left: 0%;
          }

          >.job {
            display: flex;
            flex-flow: row nowrap;
            gap: 0.5em;
            align-items: center;
            justify-content: flex-start;

            > button.job-role {
              cursor: pointer;
            }

            > button.job-title {
              font-size: 1.5em;
              text-decoration: underline;

              &:hover {
                font-weight: 600;
              }

              &:hover,
              &:focus,
              &:focus-visible {
                cursor: pointer;
              }

              &:focus-visible {
                outline: auto 1px #36c;
              }
            }
          }

          >.roles {
            display: flex;
            flex-flow: row wrap;
            gap: 0.5em;

            button {
              width: auto;
              height: auto;
              border-width: 0.125em;
              border-style: solid;
              border-color: ${design_system_1.theme.colors.turquoise[50]};
              background-color: ${design_system_1.theme.colors.turquoise[50]};
              cursor: pointer;

              >.role {
                border-color: ${design_system_1.theme.colors.turquoise[50]};
                background-color: ${design_system_1.theme.colors.turquoise[50]};

                > span {
                  font-weight: 400;
                  font-size: 0.875em;
                }
              }

              &:hover,
              &:focus,
              &:focus-visible {
                border-color: ${design_system_1.theme.colors.marine[100]};
              }
            }
          }
        }
      }

      >.infos {
        display: flex;
        flex-direction: row;
        gap: 3.2em;
        align-items: stretch;
        justify-content: stretch;
        width: 100%;

        @media (min-width: ${constants_1.sizes.tablet}) {
          flex-direction: row;
        }

        @media (max-width: ${constants_1.sizes.tablet}) {
          flex-direction: column;
        }

        > h2 {
          margin: 1em 0 0;
          font-weight: 600;

          > span {
            font-size: 1.5em;
          }
        }

        >.infos-left {
          display: flex;
          flex-direction: column;
          gap: 1.6em;
          width: auto;

          @media (min-width: ${constants_1.sizes.tablet}) {
            gap: 1.6em;
          }

          @media (max-width: ${constants_1.sizes.tablet}) {
            gap: 0.8em;
          }

          >.details {
            display: flex;
            flex-direction: column;
            gap: 1em;
            width: 100%;

            @media (max-width: ${constants_1.sizes.tablet}) {
              flex-flow: row wrap;
              width: 100%;

              >h2 {
                width: 100%;
              };

              .wrappable {
                width: 50%;
              }
            }
          }
        }

        >.infos-right {
          display: flex;
          flex-direction: column;
          gap: 1em;
          width: 70%;

          @media (min-width: ${constants_1.sizes.tablet}) {
            width: 70%;
          }

          @media (max-width: ${constants_1.sizes.tablet}) {
            align-items: center;
            justify-content: center;
            width: 100%;
          }

          >.details {
            display: flex;
            flex-direction: column;
            gap: 1em;
            width: 100%;
            margin-bottom: 1.6em;

            @media (max-width: ${constants_1.sizes.tablet}) {
              .wrappable {
                display: flex;
                flex-direction: row;
                width: 100%;
              }
            }

            >h2 {
              width: 100%;
            };

            .infos-details {
              display: flex;
              flex: 1;
              align-items: start;
              justify-content: space-between;
              width: 100%;

              .information-link {
                width: 25%;
              }
            }
          }
        }
      }

      >.description-controls {
        display: flex;
        gap: 1em;
        width: 100%;

        @media (min-width: ${constants_1.sizes.tablet}) {
          flex-flow: row nowrap;
          align-items: stretch;
          justify-content: flex-end;
        }

        @media (max-width: ${constants_1.sizes.tablet}) {
          flex-flow: column nowrap;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  >.relations {
    display: flex;
    flex-flow: row wrap;
    gap: 3em;
    align-items: baseline;
    justify-content: space-between;
    padding: 2em 12vw;

    >.relation {
      flex: 1;

      &.manager {
        > img {
          border-radius: 3.5em;
        }
      }
    }
  }
}
`;
//# sourceMappingURL=PanelPerson.styled.js.map